import { useAppSelector } from '../contexts/hooks';

/**
 * Estado de carga de las listas de configuración que llegan tras autenticar
 * (GetAllConfig: Estudios, Perfiles, SystemFields, DefinicionesCampos, etc.).
 *
 * La navegación no espera a ese payload, así que los módulos que dependen de
 * estas listas pueden montarse antes de que llegue. Usar `pending` para
 * mostrar un estado de carga en vez de un formulario o un combo vacío, y para
 * deshabilitar las acciones que guardarían datos incompletos.
 */
export const useConfigReady = () => {
  const loaded = useAppSelector((x) => x.configuration.FullConfigLoaded);
  return { loaded, pending: !loaded };
};

export default useConfigReady;
